$(document).ready(function () {

    // Determine either back button should be present or not
    getUrlParam('backUrl') ? $('.go-back-btn').css('display', 'flex') : 
        $('.go-back-btn').css('display', 'none');

    $("#nav-icon1").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("active");
        $(this).toggleClass('open');

    });

    /**
     * On Go Back Button Click 
     */
    $('.go-back-btn').click(function(e) {
        e.preventDefault();
        // window.open(getUrlParam('backUrl')),"_self";
        window.location.replace(getUrlParam('backUrl'));
    });

    /**
     * Toggle fullscreen function who work with webkit and firefox.
    */
    function toggleFullscreen() {

        //var element = document.getElementsByTagName("iframe")[0];
        var element = document.documentElement; 
        
        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

        element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
        document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };

        isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
    }

    $('.fullscreen-toggler').click(function() {
        toggleFullscreen();
    });

    $('body').show();

    $(".card").on("show.bs.collapse hide.bs.collapse", function (e) {
        if (e.type == 'show') {
            $(this).children('div:first-child').addClass('card-header-white');
        } else {
            $(this).children('div:first-child').removeClass('card-header-white');
        }
    });


    if (window.innerWidth < 992) {
        showTab(window.location.hash);
    }

    $(window).resize(function (event) {
        if (window.innerWidth >= 992) {
            $('#ticketsXlHorse').show();
            $('#bettingXlHorse').show();
            $('#statisticHorse').show();
        } else {
            showTab(window.location.hash);
        }
    });


    $('.ui-tabs-tab').click(function () {
        $(this).addClass('ui-tabs-active ui-state-active');
        showTab($(this).find('a').attr('href'));
    });

});

window.redirectToUrl = function(game, terminal = false) {

    window['token'] = getUrlParam('token');
    window['lang'] = getUrlParam('lang') !== null ? getUrlParam('lang') : 'en';
    
    if (!terminal) {
        if (getUrlParam('backUrl')) {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang + '&backUrl=' + getUrlParam('backUrl');
        } else {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang;
        }
    } else {
        window.location.href = game + '/terminal.html?token=' + token + '&lang=' + lang;
    }
}

window.getUrlParam = function(name){
   var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
   if (results==null){
      return null;
   }
   else{
      return decodeURI(results[1]) || 0;
   }
}

window.showTab = function (hash) {

    if ("undefined" === typeof hash || '' == hash) {
        hash = '#betting-tab';
    }

    $('.ui-tabs-tab').removeClass('ui-tabs-active ui-state-active');

    var targetTab = hash.replace('#', '.');

    $(targetTab).addClass('ui-tabs-active ui-state-active');

    switch (hash) {
        case '#betting-tab':
            $('#ticketsXlHorse').hide();
            $('#bettingXlHorse').show();
            $('#statisticHorse').hide();

            break;
        case '#tickets-tab':
            $('#ticketsXlHorse').show();
            $('#bettingXlHorse').hide();
            $('#statisticHorse').hide();

            break;
        case '#statistics-tab':
            $('#ticketsXlHorse').hide();
            $('#bettingXlHorse').hide();
            $('#statisticHorse').show();
            break;
    }

}


//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/js/script.js
// module id = 1568
// module chunks = 7